import {
  AUTHENTICATING_ZOOM_REQUEST, AUTHENTICATING_ZOOM_SUCCEDDED, AUTHENTICATING_ZOOM_FAILED,
  UPDATING_ZOOM_RECORDING_TOGGLE_REQUEST, UPDATING_ZOOM_RECORDING_TOGGLE_SUCCEEDED, UPDATING_ZOOM_RECORDING_TOGGLE_FAILED,
} from '../actionTypes';

import { activatingIntegrationSuccedded } from '../integrations';
import axios from 'axios';
import buildUrl from 'build-url-ts';

const apiUrl = `${process.env.REACT_APP_API_URL}`;

const INTEGRATION_BASE_URL = `${apiUrl}/api/2.0/integrations`;

export function authenticateAccount(code, integrationType) {
return function (dispatch) {
  dispatch(authenticatingAccount());

  const data = {
      code: code
  }

  let url = buildUrl(INTEGRATION_BASE_URL, {
    path: `${integrationType}`,
  });

  return axios({
    method: 'POST',
    url: url,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: data
  })
  .then((response) => {
      dispatch(authenticatingAccountSuccedded(response.data));
      dispatch(activatingIntegrationSuccedded(response.data));
  })
  .catch(error =>
      dispatch(authenticatingAccountFailed(error.errors))
  )
}
}

function authenticatingAccount() {
  return {
      type: AUTHENTICATING_ZOOM_REQUEST,
      payload: {}
  }
}

function authenticatingAccountSuccedded(json) {
  return {
      type: AUTHENTICATING_ZOOM_SUCCEDDED,
      payload: json
  }
}

function authenticatingAccountFailed(error) {
  return {
      type: AUTHENTICATING_ZOOM_FAILED,
      payload: error
  }
}

export function updateZoomRecordingToggle(enabled) {
  return function (dispatch) {
    dispatch(updatingZoomRecordingToggle());

    const url = buildUrl(INTEGRATION_BASE_URL, {
      path: `/zoom/recording-access`,
    });

    return axios({
      method: "PUT",
      url: url,
      data: enabled
    })
      .then((response) => {
        dispatch(updatingZoomRecordingToggleSucceeded(response));
      })
      .catch((error) => {
        dispatch(updatingZoomRecordingToggleFailed(error));
      });
  };
}

// Action creators
function updatingZoomRecordingToggle() {
  return { type: UPDATING_ZOOM_RECORDING_TOGGLE_REQUEST };
}

function updatingZoomRecordingToggleSucceeded(response) {
  return {
    type: UPDATING_ZOOM_RECORDING_TOGGLE_SUCCEEDED,
    payload: response,
  };
}

function updatingZoomRecordingToggleFailed(error) {
  return {
    type: UPDATING_ZOOM_RECORDING_TOGGLE_FAILED,
    payload: error,
  };
}